import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('div', {
    staticClass: "search-Result"
  }, [_c('search-box', {
    attrs: {
      "showHotKeywords": true
    },
    on: {
      "search": _vm.handleSearch
    }
  })], 1), _c('div', {
    staticClass: "pl-100 pr-100 pb-20 bf result-box"
  }, [_c('div', {
    staticClass: "pt-15 pb-15 result-box-number"
  }, [_vm._v(_vm._s(_vm.t('helpCenter.index', '共找到')) + " " + _vm._s(_vm.total) + " " + _vm._s(_vm.t('helpCenter.index', '条记录')))]), !_vm.isPending && _vm.resultList.length ? _c('ul', {
    staticClass: "result-box-list"
  }, _vm._l(_vm.resultList, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "result-box-list__li"
    }, [_c('h5', {
      staticClass: "result-box-list__li-title",
      on: {
        "click": function ($event) {
          return _vm.handleJumpToDetail(item);
        }
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.$util.filterXSS(item.title_parsed))
      }
    }), _c('span', {
      staticClass: "result-box-list__li-cate",
      domProps: {
        "innerHTML": _vm._s(_vm.$util.filterXSS('「' + item.cat1_title + ' / ' + item.cat2_title + '」'))
      }
    })]), _c('p', {
      staticClass: "result-box-list__li-desc",
      domProps: {
        "innerHTML": _vm._s(_vm.$util.filterXSS(item.content_parsed))
      }
    })]);
  }), 0) : _vm._e(), _vm.isPending ? _c('a-skeleton', {
    attrs: {
      "active": ""
    }
  }) : _vm._e(), !_vm.isPending && !_vm.resultList.length ? _c('a-empty', {
    staticClass: "mt-100",
    attrs: {
      "description": _vm.t('暂无数据')
    }
  }) : _vm._e(), !_vm.isPending && _vm.resultList.length ? _c('my-pagination', {
    staticClass: "mt-20",
    attrs: {
      "total": _vm.total,
      "value": _vm.page,
      "page-size": _vm.pageSize
    },
    on: {
      "onChange": _vm.handlePageChange,
      "update:pageSize": function ($event) {
        _vm.pageSize = $event;
      },
      "update:page-size": function ($event) {
        _vm.pageSize = $event;
      }
    }
  }) : _vm._e()], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };